import { render, staticRenderFns } from "./roleSelectForm.vue?vue&type=template&id=56a71554&scoped=true&"
import script from "./roleSelectForm.vue?vue&type=script&lang=js&"
export * from "./roleSelectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a71554",
  null
  
)

export default component.exports